<template>
	<div class="password-confirmation-container">
		<img src="~@/common/assets/images/akkodis-letter.svg" alt="letter">
		<h2>Check your email with your new password</h2>
		<span>If there is an email in our system, we will send the password to that email address</span>
		<button @click="returnToSignIn">GO BACK TO LOGIN</button>
	</div>
</template>

<script>
export default {
	name: "ConfirmationForgotPassword",
	methods: {
		returnToSignIn() {
			this.$router.push(`/sign-in`)
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.password-confirmation-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 100%;
	max-width: 480px;
	gap: 16px;
	margin-top: 50px;
	margin-bottom: 50px;

	img {
		margin-bottom: 30px;
	}

	h2 {
		font-family: Tiempos Headline, serif;
		font-size: 28px;
		font-weight: 500;
		line-height: 28px;
		text-align: center;
		margin: 0;
		max-width: 300px;
	}

	span {
		font-family: Roboto, serif;
		font-size: 17px;
		font-weight: 300;
		line-height: 22px;
		text-align: center;
		margin: 0;
	}

	button {
		margin-top: 30px;
		min-width: 234px;
		min-height: 54px;
		padding: 16px 24px;
		gap: 12px;
		cursor: pointer;
		background: $color-hover-button;
		border: none;
		font-family: Roboto, serif;
		font-size: 17px;
		font-weight: 400;
		line-height: 22px;
		text-align: center;
		text-transform: uppercase;
	}
}
</style>
